import { Component, Input } from '@angular/core';
import { BANNER_MESSAGES } from 'src/app/core/constants/General-constants';

@Component({
  selector: 'app-recommendations-banner',
  templateUrl: './recommendations-banner.component.html',
  styleUrls: ['./recommendations-banner.component.scss']
})
export class RecommendationsBannerComponent {
  @Input() bannerText: string;
  recomendation: string = BANNER_MESSAGES.RECOMMENDATION;
  appStore: string = BANNER_MESSAGES.APP_STORE;
  playStore: string = BANNER_MESSAGES.PLAY_STORE;
  or: string = BANNER_MESSAGES.OR;
}
